

import React, { useState } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

// Company
import CompanyIndex from './components/pages/company/Index';
import CompanyCreate from "./components/pages/company/Create";
import CompanyEdit from "./components/pages/company/Edit";
// Item
import ItemIndex from './components/pages/Item/Index';
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemDetail from "./components/pages/Item/Detail";
// Table Name
import TableNameIndex from './components/pages/TableName/Index';
import TableNameCreate from "./components/pages/TableName/Create";
import TableNameEdit from "./components/pages/TableName/Edit";
// KOT
import KOTCreate from "./components/pages/KOT/Create";
import KOTEdit from "./components/pages/KOT/Edit";
import EstimatePrint from "./components/pages/KOT/Estimate";
//Sale
import SaleIndex from './components/pages/Sale/Index';
import SaleEdit from "./components/pages/Sale/Edit";
import BillPrint from "./components/pages/Sale/Bill";
import SaleDetail from "./components/pages/Sale/Detail";


//User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//Report
import SaleRegister from "./components/pages/Report/SaleRegister";
import SalePayment from "./components/pages/Report/SalePayment";
import SaleGST from "./components/pages/Report/SaleGST";
import SaleEditDetails from "./components/pages/Report/SaleEditDetails";


import Home from "./components/pages/Home";
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";
import { AuthProvider, useAuth } from "./AuthContext";
import Logout from "./Logout";
import SessionTimeout from "./SessionTimeout";

import InventoryIcon from '@mui/icons-material/Inventory';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import StoreIcon from '@mui/icons-material/Store';
import CategoryIcon from '@mui/icons-material/Category';
import SummarizeIcon from '@mui/icons-material/Summarize';
import ArticleIcon from '@mui/icons-material/Article';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import EditNoteIcon from '@mui/icons-material/EditNote';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };


  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };




  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName } = useAuth();

  return (
    <Router>
      <AuthProvider>
        <SessionTimeout />
        <AppBar position="static" style={{ backgroundColor: '#36454F' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" component="div" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Link to="/Home" style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}>
                  <FiHome style={{ marginRight: '8px' }} />
                  <Typography variant="h5" className="dual-text" component="div" style={{ marginLeft: '16px', fontWeight: 'bolder' }}>
                    {companyName}
                  </Typography>
                </Link>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Logout />
              </div>
            </Typography>
          </Toolbar>
        </AppBar>
        {roleName !== "Counter" && (
          <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose}>
            <h4 className="dual-tone-text" style={{ fontWeight: 'bolder', marginTop: '18px' }}> {companyName}</h4>
            <List>
              <ListItem button component={NavLink} to="/Home" activeClassName="selected" onClick={handleDrawerClose}>
                <ListItemText primary="HOME" />
              </ListItem>

              <ListItem button onClick={handleMasterClick}>
                <ListItemText primary="MASTER" />
                {masterOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={masterOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/CompanyIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <StoreIcon style={{ color: 'blueviolet' }} /><ListItemText primary="COMPANY" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <CategoryIcon style={{ color: 'darkcyan' }} /><ListItemText primary="ITEM" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/TableNameIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <TableRestaurantIcon style={{ color: 'darkseagreen' }} /><ListItemText primary="TABLE" style={{ marginLeft: '3px' }} />
                  </ListItem>
                </List>
              </Collapse>

              <ListItem button onClick={handleItemClick}>
                <ListItemText primary="SALE" />
                {itemOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={itemOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/SaleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <AddShoppingCartIcon style={{ color: 'darkblue' }} /><ListItemText primary="SALE" style={{ marginLeft: '3px' }} />
                  </ListItem>
                </List>
              </Collapse>



              <ListItem button onClick={handleReportClick}>
                <ListItemText primary="REPORT" />
                {reportOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={reportOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/SaleRegister" activeClassName="selected" onClick={handleDrawerClose}>
                    <InventoryIcon style={{ color: 'blueviolet' }} /><ListItemText primary="SALE REGISTER" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SalePayment" activeClassName="selected" onClick={handleDrawerClose}>
                    <ArticleIcon style={{ color: 'darkorange' }} /><ListItemText primary="SALE DETAILS" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SaleGST" activeClassName="selected" onClick={handleDrawerClose}>
                    <SummarizeIcon style={{ color: 'darkolivegreen' }} /><ListItemText primary="SALE REGISTER GST" style={{ marginLeft: '3px' }} />
                  </ListItem>

                  <ListItem button component={NavLink} to="/SaleEditDetails" activeClassName="selected" onClick={handleDrawerClose}>
                    <EditNoteIcon style={{ color: '#009E73' }} /><ListItemText primary="EDITED BILL DETAILS" style={{ marginLeft: '3px' }} />
                  </ListItem>

                </List>
              </Collapse>

              <ListItem button onClick={handleUserClick}>
                <ListItemText primary="USER" />
                {userOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>

              <Collapse in={userOpen} timeout="auto" unmountOnExit>
                <List style={{ paddingLeft: '16px' }}>
                  <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose}>
                    <PeopleAltIcon style={{ color: 'blueviolet' }} /><ListItemText primary="USER" style={{ marginLeft: '3px' }} />
                  </ListItem>
                  {isSuperAdmin && companyId == superCompanyId && (
                    <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose}>
                      <AccessibilityIcon style={{ color: 'darkorange' }} /><ListItemText primary="Role" style={{ marginLeft: '3px' }} />
                    </ListItem>
                  )}

                  <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose}>
                    <SecurityIcon style={{ color: 'darkolivegreen' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px' }} />
                  </ListItem>
                </List>
              </Collapse>

              {/* Add more menu items as needed */}
            </List>
          </Drawer>
        )}


        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/Home" exact component={Home} />

          {/* Company */}
          <Route path="/CompanyIndex" component={CompanyIndex} />
          <Route path="/CompanyCreate" component={CompanyCreate} />
          <Route path="/CompanyEdit/:id" component={CompanyEdit} />

          {/* Item */}
          <Route path="/ItemIndex" component={ItemIndex} />
          <Route path="/ItemCreate" component={ItemCreate} />
          <Route path="/ItemEdit/:id" component={ItemEdit} />
          <Route path="/ItemDetail/:id" component={ItemDetail} />
          {/* TableName */}
          <Route path="/tableNameIndex" component={TableNameIndex} />
          <Route path="/tableNameCreate" component={TableNameCreate} />
          <Route path="/tableNameEdit/:id" component={TableNameEdit} />
          {/* KOT */}
          <Route path="/kotCreate/:id" component={KOTCreate} />
          <Route path="/kotEdit/:id" component={KOTEdit} />
          <Route path="/estimatePrint/:id" component={EstimatePrint} />
          {/* Sale */}
          <Route path="/saleIndex" component={SaleIndex} />
          <Route path="/saleEdit/:id" component={SaleEdit} />
          <Route path="/billPrint/:id" component={BillPrint} />
          <Route path="/SaleDetail/:id" component={SaleDetail} />

          {/* User */}
          <Route path="/UserIndex" component={UserIndex} />
          <Route path="/UserCreate" component={UserCreate} />
          <Route path="/UserEdit/:id" component={UserEdit} />
          <Route path="/UserDetail/:id" component={UserDetail} />
          <Route path="/PasswordChange" component={PasswordChange} />
          {/* Role */}
          <Route path="/RoleIndex" component={RoleIndex} />
          <Route path="/RoleDetail/:id" component={RoleDetail} />
          {/* Report */}
          <Route path="/SaleRegister" component={SaleRegister} />
          <Route path="/SalePayment" component={SalePayment} />
          <Route path="/SaleGST" component={SaleGST} />
          <Route path="/SaleEditDetails" component={SaleEditDetails} />

          {/* Add your other routes here */}
        </Switch>
      </AuthProvider >
    </Router>
  );
};

export default App;

